package com.hyperether.goodjob.scenes.jobs.components

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.shape.CircleShape
import androidx.compose.material.Text
import androidx.compose.material3.Checkbox
import androidx.compose.material3.CheckboxDefaults
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.draw.scale
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.input.pointer.PointerIcon
import androidx.compose.ui.input.pointer.pointerHoverIcon
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.style.TextOverflow
import com.hyperether.goodjob.models.Job
import com.hyperether.goodjob.models.Site
import com.hyperether.goodjob.resources.Res
import com.hyperether.goodjob.resources.no_information
import com.hyperether.goodjob.scenes.components.clickableWithPointer
import com.hyperether.goodjob.theme.BlueApp
import com.hyperether.goodjob.util.StatusColor
import com.hyperether.goodjob.util.toScaleDp
import com.hyperether.goodjob.util.toScaleSp
import com.hyperether.resources.stringResource

@Composable
fun JobsItemWeb(
    sites: Map<String, Site>,
    job: Job,
    isInEditMode: Boolean,
    selectedJobs: MutableList<Job>,
    isEvenRow: Boolean,
    onJobSelected: (Job, Boolean) -> Unit,
    onItemClick: () -> Unit
) {
    val backgroundColor = if (isEvenRow) Color(0xFFF9F9F9) else Color.White
    Row(
        verticalAlignment = Alignment.CenterVertically,
        modifier = Modifier
            .fillMaxWidth()
            .height(48.toScaleDp())
            .background(backgroundColor)
            .clickableWithPointer {
                onItemClick()
            }
            .pointerHoverIcon(PointerIcon.Hand)
            .padding(horizontal = 22.toScaleDp())
    ) {
        if (isInEditMode) {
            Checkbox(
                checked = selectedJobs.contains(job),
                onCheckedChange = { checked ->
                    onJobSelected(job, checked)
                },
                modifier = Modifier.padding(end = 8.toScaleDp()).scale(1f),
                colors = CheckboxDefaults.colors(
                    checkedColor = BlueApp,
                    uncheckedColor = com.hyperether.goodjob.theme.Divider
                )
            )
        }
        val jobTitle = job.jobTitle ?: " "
        Text(
            text = jobTitle,
            color = Color(0xFF34618E),
            fontSize = 14.toScaleSp(),
            fontWeight = FontWeight.Bold,
            modifier = Modifier.weight(0.9f),
            maxLines = 1,
            overflow = TextOverflow.Ellipsis
        )

        val contactName = sites[job.contactSiteId]?.siteName
            ?: sites[job.contactSiteId]?.personName
            ?: stringResource(Res.string.no_information)
        Text(
            text = contactName,
            color = Color(0xFF323232),
            fontSize = 14.toScaleSp(),
            modifier = Modifier.weight(1.1f),
            maxLines = 1,
            overflow = TextOverflow.Ellipsis
        )

        val contactAddress = sites[job.contactSiteId]?.addressObject?.address
            ?: stringResource(Res.string.no_information)
        Text(
            text = contactAddress,
            color = Color(0xFF555555),
            fontSize = 14.toScaleSp(),
            modifier = Modifier.weight(1.6f),
            maxLines = 1,
            overflow = TextOverflow.Ellipsis
        )

        val jobTime = job.start_at?.let { start ->
            job.end_at?.let { end ->
                "$start - $end"
            }
        } ?: ""
        Text(
            text = jobTime,
            color = Color(0xFF555555),
            fontSize = 14.toScaleSp(),
            modifier = Modifier.weight(0.6f),
            maxLines = 1,
            overflow = TextOverflow.Ellipsis
        )

        val assignee = job.assignees?.employees?.mapNotNull {
            it?.getName()
        }?.joinToString(", ") ?: ""
        Text(
            text = assignee,
            color = Color(0xFF323232),
            fontSize = 14.toScaleSp(),
            modifier = Modifier.weight(0.5f),
            maxLines = 1,
            overflow = TextOverflow.Ellipsis
        )
        Box(
            modifier = Modifier
                .weight(0.5f)
                .fillMaxWidth(),
            contentAlignment = Alignment.Center
        ) {
            Box(
                modifier = Modifier
                    .size(16.toScaleDp())
                    .clip(CircleShape)
                    .background(StatusColor.getStatusColor(job.status))
            )
        }
    }
}